import {
    SelectionPanelCheckShape,
    SelectionPanelCheckStyle,
    SelectionPanelGroup,
    SelectionPanelGroupComponentSpacing,
    SelectionPanelGroupLayoutStyle,
    SelectionPanelGroupSelectionType,
    SelectionPanelGroupStyleMode,
    SelectionPanelGroupTheme,
} from '@apply/components';
import { BorrowerType } from '../constants/borrowerSelection';

const ENTITY_PANEL_ID = 'borrowerType_entity';
const BCLIENT_PANEL_ID = 'borrowerType_bClient';

interface BorrowerTypeFieldProps {
    value: BorrowerType;
    onChange: (borrowerType: BorrowerType) => void;
    disabled: boolean;
    required: boolean;
}

/** "Borrower Only" or "Borrower with B-Client"; switching clears the current pick (see BorrowerSelector). */
export const BorrowerTypeField = ({ value, onChange, disabled, required }: BorrowerTypeFieldProps) => {
    const handleChange = (selections: string[]) => {
        // Clicking the selected option again deselects it; there's always a borrower type, so that's ignored
        if (selections.length === 0) {
            return;
        }
        onChange(selections[0] === BCLIENT_PANEL_ID ? BorrowerType.BClient : BorrowerType.Entity);
    };

    return (
        <SelectionPanelGroup
            id='borrowerType'
            items={[
                { id: ENTITY_PANEL_ID, children: 'Borrower Only', enabled: !disabled },
                { id: BCLIENT_PANEL_ID, children: 'Borrower with B-Client', enabled: !disabled },
            ]}
            selectedPanels={[value === BorrowerType.BClient ? BCLIENT_PANEL_ID : ENTITY_PANEL_ID]}
            set_selectedPanels={handleChange}
            selectionType={SelectionPanelGroupSelectionType.Single}
            theme={SelectionPanelGroupTheme.Blue}
            styleMode={SelectionPanelGroupStyleMode.Condensed}
            checkShape={SelectionPanelCheckShape.Circle}
            checkStyle={SelectionPanelCheckStyle.Fill}
            label='Borrower'
            required={required}
            layoutStyle={SelectionPanelGroupLayoutStyle.Horizontal}
            labelWidth='100px'
            wrapPanels={true}
            componentSpacing={SelectionPanelGroupComponentSpacing.StandardSpacing}
        />
    );
};
